/* eslint-disable */
// Web build of InAppWebView: the page is shown in an <iframe> inside the app.
// (If a site forbids being embedded, the page stays blank; its server must
// then allow https://dev.webapp.pompi.nl / https://webapp.pompi.nl in
// "frame-ancestors" / X-Frame-Options.)
import {Modal, StyleSheet, View} from 'react-native';
import AuthHeader from './AuthHeader';
import {colors} from '../config/theme';

const InAppWebView = ({visible, title, url, onClose}) => (
  <Modal visible={!!visible} animationType="slide" onRequestClose={onClose}>
    <View style={styles.screen}>
      <AuthHeader title={title || ''} onBack={onClose} />
      {url ? (
        <iframe
          title={title || 'page'}
          src={url}
          style={{flex: 1, width: '100%', border: 'none'}}
        />
      ) : null}
    </View>
  </Modal>
);

const styles = StyleSheet.create({
  screen: {
    flex: 1,
    backgroundColor: colors.background,
  },
});

export default InAppWebView;